export { default } from './StaticPageHeadline';
